import { BaseModel } from "ReduxStore/index";

export interface EatLocal {
  offerClaimed: boolean;
}

export default class EatLocalModel extends BaseModel<EatLocal> {
  static resource = "EatLocal";
}
